import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import Swal from 'sweetalert2';
import { IGeoFence } from "../../models/GeoFence";

const Fences: React.FC = () => {
    const [fences, setFences] = useState<IGeoFence[]>([]);
    const navigate = useNavigate();

    const fetchFences = () => {
        fetch(`${process.env.REACT_APP_API_URL}/geofences`, { method: 'GET' })
            .then((res) => res.json())
            .then((json) => {
                if (json.success) {
                    setFences(json.geoFences);
                }
            })
            .catch(err => console.error("Error fetching fences:", err));
    };

    useEffect(() => {
        fetchFences();
    }, []);

    const onDeleteFence = (id: number) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                fetch(`${process.env.REACT_APP_API_URL}/geofences/${id}`, {
                    method: 'DELETE',
                })
                    .then((res) => res.json())
                    .then((json) => {
                        if (json.success) {
                            Swal.fire('Deleted!', 'Geo Fence has been deleted.', 'success');
                            fetchFences();
                        }
                    });
            }
        });
    };

    return (
        <>
            <div className="content-header pb-6 flex justify-between">
                <div className="content-header-label">Geo Fences</div>
                <div className="content-header-actions">
                    <Button variant="contained" onClick={() => navigate('/fence/new')}>Add New Geo Fence</Button>
                </div>
            </div>
            <div className="content-body">
                <table className="table-auto border w-full">
                    <thead>
                        <tr>
                            <th className="font-bold p-2 border-b text-left w-2">No</th>
                            <th className="font-bold p-2 border-b text-left w-full">Fence Name</th>
                            <th className="font-bold py-2 px-4 border-b text-left">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {fences.map((fence, i) => (
                            <tr key={fence.geo_fence_id}>
                                <td className="p-2 border-b text-left">{i + 1}</td>
                                <td className="p-2 border-b text-left">{fence.geo_fence_name}</td>
                                <td className="py-2 px-4 border-b text-left whitespace-nowrap">
                                    <Link className="px-2 py-1 text-blue-600 hover:underline mr-2" to={`/fence/${fence.geo_fence_id}`}>Edit</Link>
                                    <Button color="error" size="small" onClick={() => onDeleteFence(fence.geo_fence_id!)}>Delete</Button>
                                </td>
                            </tr>
                        ))}
                        {fences.length === 0 && (
                            <tr>
                                <td colSpan={3} className="p-4 text-center text-gray-500">No geo fences found.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </>
    );
};

export default Fences;
